<div class="progressive-image-shell">
  @if (thumbnailSrc) {
    <img
      class="progressive-image progressive-image-thumb"
      [class.is-hidden]="highResLoaded()"
      [src]="thumbnailSrc"
      (error)="onThumbnailError($event)"
      alt=""
      aria-hidden="true"
      />
  }
  <img
    class="progressive-image progressive-image-full"
    [class.is-visible]="highResLoaded() || !thumbnailSrc"
    [src]="src"
    (load)="onHighResLoad()"
    (error)="onHighResError($event)"
    [alt]="alt"
    />
  </div>